import React from "react"
import { Box, Text } from "@chakra-ui/react"

const EmptyState = () => (
  <Box
    position="absolute"
    top="50%"
    left="50%"
    transform="translate(-50%, -50%)"
    textAlign="center"
    color="gray.400"
  >
    <Text fontSize="sm" fontWeight="medium">
      Empty Badge Template
    </Text>
    <Text fontSize="xs">Add elements from the palette</Text>
  </Box>
)

export default EmptyState
